module.exports = {"name":"Courses Search","what":{"description":"Functionality that allows users to navigate through available content","requirements":["Ability to search through content","Possible auto-complete / suggestions functionalities"]},"planning":{"due":"Aug 15","completed":false,"started":false,"duration":"40 hours"},"who":{"description":"An enthusiast with advanced JavaScript knowledge","level":"advanced","skills":["JavaScript","GraphQL","Apollo Client","CSS","React"],"team":["Jan Hein Hoogstad"]},"why":"It increases the usability of the platform's \"growing content\" offer"}


//////////////////
// WEBPACK FOOTER
// ./src/features/courses-search.yaml
// module id = 519
// module chunks = 0